import { ATHOSTreeviewAddProvider } from "./add";
import { ATHOSTreeviewFuncsProvider } from "./funcs";
import { ATHOSTreeviewMoveProvider } from "./move";

export const Providers = [ATHOSTreeviewAddProvider, ATHOSTreeviewMoveProvider, ATHOSTreeviewFuncsProvider];
